var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 171,
    viewBox: "0 0 143 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_44681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.226 168.386H2.77441L17.3825 129.878H125.612L140.226 168.386Z",
    fill: "url(#paint0_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.565 129.878H17.4297L26.866 121.155H115.934L125.565 129.878Z",
    fill: "url(#paint1_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 166.121H0V171H143V166.121Z",
    fill: "url(#paint2_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.742 135.342H34.2993V158.387H108.742V135.342Z",
    fill: "url(#paint3_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4971 63.4753V0L92.0426 41.7905L71.4971 63.4753Z",
    fill: "url(#paint4_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4972 63.4753V0L50.9517 41.7905L71.4972 63.4753Z",
    fill: "url(#paint5_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.976 48.4905L71.4971 63.4752L92.0426 41.7905L137.976 48.4905Z",
    fill: "url(#paint6_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01855 48.4905L71.497 63.4752L50.9515 41.7905L5.01855 48.4905Z",
    fill: "url(#paint7_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.582 126.951L104.736 81.0206L71.4971 63.4753L112.582 126.951Z",
    fill: "url(#paint8_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4971 63.4753V105.266L112.582 126.951L71.4971 63.4753Z",
    fill: "url(#paint9_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4116 126.951L38.2576 81.0206L71.4968 63.4753L30.4116 126.951Z",
    fill: "url(#paint10_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4968 63.4753V105.266L30.4116 126.951L71.4968 63.4753Z",
    fill: "url(#paint11_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.976 48.4905L104.736 81.0205L71.4971 63.4752L137.976 48.4905Z",
    fill: "url(#paint12_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01855 48.4905L38.2578 81.0205L71.497 63.4752L5.01855 48.4905Z",
    fill: "url(#paint13_linear_288_44681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.681 62.1152L137.976 48.4905L73.3819 64.2085L112.582 126.951L71.6148 65.5272L30.4118 126.578L69.8242 64.244L5.01855 48.4905L70.4839 62.1329L71.5029 0.479004L72.681 62.1152Z",
    fill: "url(#paint14_radial_288_44681)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_288_44681",
    x1: 71.4978,
    y1: 164.528,
    x2: 71.4978,
    y2: 140.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E0500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72281A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_288_44681",
    x1: 71.4978,
    y1: 129.006,
    x2: 71.4978,
    y2: 123.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E0500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72281A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_288_44681",
    x1: 71.4992,
    y1: 170.509,
    x2: 71.4992,
    y2: 167.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E0500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72281A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_288_44681",
    x1: 40.1386,
    y1: 128.584,
    x2: 105.232,
    y2: 166.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C55C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_288_44681",
    x1: 81.8975,
    y1: 53.2299,
    x2: 70.3664,
    y2: -0.225664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C55C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4788,
    stopColor: "#FFC841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_288_44681",
    x1: 61.098,
    y1: 53.2299,
    x2: 72.6291,
    y2: -0.225666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#FFC841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C55C18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_288_44681",
    x1: 136.624,
    y1: 50.2074,
    x2: 84.1303,
    y2: 52.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_288_44681",
    x1: 6.37121,
    y1: 50.2074,
    x2: 58.865,
    y2: 52.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_288_44681",
    x1: 116.303,
    y1: 113.264,
    x2: 75.1728,
    y2: 63.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C55C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4788,
    stopColor: "#FFC841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_288_44681",
    x1: 65.963,
    y1: 78.0308,
    x2: 110.732,
    y2: 128.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C55C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4788,
    stopColor: "#FFC841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_288_44681",
    x1: 26.6939,
    y1: 113.263,
    x2: 67.8233,
    y2: 63.7044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C55C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4788,
    stopColor: "#FFC841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_288_44681",
    x1: 77.0323,
    y1: 78.0306,
    x2: 32.2646,
    y2: 128.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#FFC841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C55C18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_288_44681",
    x1: 135.112,
    y1: 48.4144,
    x2: 92.3457,
    y2: 69.9331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C55C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4788,
    stopColor: "#FFC841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_288_44681",
    x1: 7.88327,
    y1: 48.4144,
    x2: 50.6497,
    y2: 69.9331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C55C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4788,
    stopColor: "#FFC841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_288_44681",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.5489 75.3931) rotate(35.5699) scale(64.8815 64.9642)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#813900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#C55C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8A3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_44681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 171,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophie);
export default __webpack_public_path__ + "static/media/trophie.202b491c3c6d5139193b78e1d3d95660.svg";
export { ForwardRef as ReactComponent };